  <ion-list *ngIf="isSelectable">
    <ion-radio-group (ionChange)="selectCamera($event)">
      <ion-list-header color="light">
        <ion-label>{{ videoStreamProvider.name || 'Facility' }}</ion-label>
        <ion-button (click)="removeFacilityFn()" color="danger">
          <ion-icon slot="icon-only" name="remove-circle"></ion-icon>
        </ion-button>
      </ion-list-header>
      <ion-item *ngFor="let camera of videoStreamProvider.cameras">
        <ion-radio label-placement="start" [value]="camera" mode="md" justify="space-between">{{ camera.name }}</ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>

  <ion-list *ngIf="!isSelectable">
    <ion-item *ngFor="let camera of videoStreamProvider.cameras">
      <ion-label>{{ camera.name }}</ion-label>
    </ion-item>
    
  </ion-list>